// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2dQfB","name":"styles_name__2ebru","logoContainer":"styles_logoContainer__3AnMp"};